import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../../common/breadcrumbs";
import * as faqServices from "../../../services/faq.services";
import { SWAL_SETTINGS, INPUT_LENGTH_100, INPUT_LENGTH_500 } from "../../../../../utils/Constants";
import {
  globalLoader,
  handleServerValidations,
} from "../../../../../utils/commonfunction";
import { Tooltip, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import CustomCkeditor from "../../../common/customeditor";



const FAQAdd = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { t } = useTranslation()
  const [submitted, setSubmitted] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [initialValues, setInitialValues] = useState({
    title: "",
    title_ja: "",
    name: "",
    slug: "",
    description: "",
    short_description_ja: "",
    meta_tags: "",
    meta_keyword: "",
    richtext: "",
    title_de: "",
    richtext_ja: "",
  });

  

  const breadcrumbs = [
    { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard/1" },
    { title: t("admin.faq.link_faq"), url: "/admin/cms/faq/list/1" },
    { title: t("admin.faq.link_add"), url: "" },
  ];

  
  

  useEffect(() => {
    setInitialValues({
      title: state && state?.title ? state?.title : "",
      title_ja: state && state?.title_ja ? state?.title_ja : "",
      slug: state && state?.slug ? state?.slug : "",
      status: state && state?.status ? state.status : "",
      menu_location: state && state?.menu_location ? state.menu_location : "",
      description:
        state && state?.description ? state?.description : "",
      short_description_ja:
        state && state?.short_description_ja ? state?.short_description_ja : "",
      richtext: state && state?.description ? state?.description : "",
      richtext_ja: state && state?.richtext_ja ? state?.richtext_ja : "",

    });
    setDataLoaded(true);
  }, []);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (
        <Formik
          initialValues={initialValues}
          validateOnBlur={false}
          validate={(values) => {
            const error = {};
            if (!values.title || !values.title.trim())
              error.title = "admin.faq.label_title_error";
            if (values.title.length > INPUT_LENGTH_500)
              error.title = "admin.faq.validation_err_reached_maximum_length";
            if (!values.description || !values.description.trim())
              error.description = "admin.faq.label_description_error";

            return error;
          }}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitted(true);
            globalLoader(true);
            console.log(values);
            let formData = new FormData();
            formData.append("title", values.title);
            formData.append("description", values.description);
            faqServices
              .Add(formData)
              .then((response) => {
                setSubmitting(false);
                if (response.success) {
                  Swal.fire({
                    icon: "success",
                    text: response.message,
                    ...SWAL_SETTINGS,
                  });
                  setTimeout(() => {
                    resetForm({ values: "" });
                    globalLoader(false);
                    navigate(`/admin/cms/faq/list/1`);
                  }, 1000);
                } else {
                  Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                  });
                  setSubmitted(false);
                  globalLoader(false);
                }
              })
              .catch((error) => {
                console.log("error ====> ", error);
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body">
                      <div>
                        <h6 className="main-content-label mb-3">{t("admin.faq.add_faq")}</h6>
                      </div>
                      <div className="row row-sm">

                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="title" className="text-left d-flex">
                            {t("admin.faq.list_heading_title")}:<span className="requirestar">*</span>
                            {/* <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>
                                  {t("admin.pages.tooltip_page_title")}
                                </Tooltip>
                              }
                            >
                              <span className="field-more-info mt-1 ms-1 cp">
                                ?
                              </span>
                            </Whisper> */}
                          </label>
                          <input
                            name="title"
                            id="title"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title}
                            className="form-control"
                            placeholder={t("admin.faq.faq_title_placeholder")}
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.title && touched.title && t(errors.title)}
                          </span>
                        </div>
                        <div className="col-lg-12 text-center form-group">
                          <label htmlFor="description" className="text-left d-flex">
                            {t("admin.faq.label_description")}:<span className="requirestar">*</span>
                          </label>
                          <CustomCkeditor
                            fieldname={"description"}
                            setFieldValue={setFieldValue}
                            value={values.description}
                            setFieldTouched={setFieldTouched}
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.description &&
                              touched.description &&
                              t(errors.description)}
                          </span>
                        </div>
                        <div className="">
                          <button
                            className="btn btn-main-primary signbtn mr-2"
                            type="submit"
                            disabled={submitted ? true : null}
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("admin.button.btn_submit")}
                          </button>
                          <button
                            className="btn ripple btn-secondary"
                            type="button"
                            disabled={submitted ? true : null}
                            onClick={() => navigate(-1)}
                          >
                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                            {t("admin.button.btn_cancel")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      ) : (
        <></>
      )}
    </>
  );
};

export default FAQAdd;
